import { useSendReplyToSupportTicket, useTicketQuery } from '#/api/api.portal';
import { SupportAttachment } from '#/api/types';
import Button from '#/components/Button/Button';
import { InputWithLabel } from '#/components/InputWIthLabel/InputWIthLabel';
import Loader from '#/components/Loader/Loader';
import { UploadAttachments } from '#/components/UploadAttachments/UploadAttachments';
import { useAppNavigation, useAppRoute } from '#/navigation/navigation.ref';
import { TicketHeader } from '#/screens/support/TicketHeader';
import { ToasterContext } from '#/toaster/toaster.provider';
import { formatDate } from '#/utils';
import { useContext, useState } from 'react';
import styles from './Support.module.scss';

const AttachmentList = ({ attachments = [] }: { attachments: SupportAttachment[] }) => {
  if (attachments.length === 0) {
    return null;
  }

  return (
    <div className={styles.attachmentList}>
      {attachments.map(a => (
        <div className={styles.attachment}>
          <a href={a.url} target="_BLANK">
            <img src={a.url} alt={alert.name} />
          </a>
        </div>
      ))}
    </div>
  );
};

export const SingleTicket = () => {
  const route = useAppRoute<'Support'>();
  const navigation = useAppNavigation();
  const { error, success } = useContext(ToasterContext);

  const [reply, setReply] = useState('');
  const [attachments, setAttachments] = useState<File[]>([]);
  const { isPending, mutateAsync } = useSendReplyToSupportTicket();

  const ticketId = route.params?.ticket || '';
  const { data: ticket, isLoading: isLoading } = useTicketQuery(ticketId);

  const handleSubmit = async () => {
    if (!reply) {
      error({ message: 'You need to enter message to submit' });
      return;
    }

    const formData = new FormData();
    formData.append('body', reply);
    attachments.forEach((file, index) => {
      formData.append(`attachments[${index}]`, file);
    });

    await mutateAsync({
      id: ticketId,
      body: formData,
    });

    setAttachments([]);
    setReply('');

    success({ message: 'Reply has been sent' });
  };

  return (
    <>
      {isLoading && <Loader size="large" />}
      {!ticket && !isLoading && (
        <div className={styles.notFound}>
          Support ticket not found
          <Button onPress={() => navigation.navigate('Support')}>Go back</Button>
        </div>
      )}
      {ticket && (
        <div className={styles.ticketDetails}>
          <div className={styles.block}>
            <TicketHeader ticket={ticket} />
            <div className={styles.ticketDescription}>{ticket.descriptionText}</div>
            <AttachmentList attachments={ticket.attachments} />
          </div>
          {ticket.conversations?.map(conversation => (
            <div className={`${styles.block} ${styles.conversation}`} key={conversation.id}>
              <div className={styles.ticketHeader}>
                <h4>{conversation.userId === ticket.requesterId ? 'You' : 'Streamster'}</h4>
                <div>{formatDate(conversation.createdAt)}</div>
              </div>
              <div className={styles.ticketDescription}>{conversation.bodyText}</div>
              <AttachmentList attachments={conversation.attachments} />
            </div>
          ))}
          {ticket.status < 4 && (
            <div className={`${styles.replyBox} ${styles.block} ${styles.form}`}>
              <InputWithLabel name="Reply" value={reply} onChange={setReply} multiline />
              <InputWithLabel name="Attachments">
                <UploadAttachments value={attachments} onChange={setAttachments} />
              </InputWithLabel>
              <div className={styles.formSubmitContainer}>
                <Button loading={isPending} onPress={handleSubmit} disabled={!reply}>
                  Send reply
                </Button>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
